const groupPrefix = createApiRoute(ApiModule.SYSTEM, ApiDataModel.APP_VERSION)

export const apiAppVersion = {
	fetchAppVersion: async (): Promise<IAppVersionModel> => {
		const { data } = await apiCommon<IAppVersion>(groupPrefix, { method: 'GET' })
		return AppVersion(data)
	},
	updateAppVersion: async (model: IAppVersionModel): Promise<void> => {
		await apiCommon(groupPrefix, {
			method: 'POST',
			body: AppVersionToPayload(model),
		})
	},
}
